import React from 'react'
import { Box, Modal } from '@mui/material'
import { ModalContent } from '../../../common/components'
import { t } from 'i18next'
import FloorRaiseModal from './modalFloorRaise'
import { type ProjectDto, type SystemInfoDto } from '../../../common/services'
import KeyTranslation from '../../../common/KeyTranslation.json'
interface FloorRaiseModalProps {
  open: boolean
  onClose: () => void
  project?: ProjectDto
  systemData?: SystemInfoDto
  systemDatarefetch: any
  unitId: number | undefined
}

export default function ContainerFloorRaiseModal ({ open, onClose, unitId, project, systemData, systemDatarefetch }: FloorRaiseModalProps): JSX.Element {
  return (
    <Modal open={open} onClose={onClose}>
      <Box>
        <ModalContent onClose={onClose} title={t(KeyTranslation.Common_Location_metrics)}>
          {
            <FloorRaiseModal
              open={open}
              onClose={onClose}
              title={t(KeyTranslation.System_Popup_Floor_raise)}
              project={project}
              systemData={systemData}
              systemDatarefetch={systemDatarefetch}
              unitId={unitId}
            />
          }
        </ModalContent>
      </Box>
    </Modal>
  )
}
